export const issueSummaryNodes = view => [
  view.state.schema.nodes.form_label.create({id: 'summary'}, view.state.schema.text('Summary')),
  view.state.schema.nodes.form_input.create({id: 'summary', name: 'summary'})
];